import React from "react";
import { DefaultPageLayout } from "../ui/layouts/DefaultPageLayout";
import { NavigationProps } from "../types";

interface AppLayoutProps extends NavigationProps {
  children: React.ReactNode;
  isModalOpen?: boolean; // <-- MODIFICATION: Add prop
}

export const AppLayout: React.FC<AppLayoutProps> = ({
  children,
  currentPage,
  onNavigate,
  isModalOpen, // <-- MODIFICATION: Receive prop
}) => {
  return (
    // <-- MODIFICATION: Pass prop down -->
    <DefaultPageLayout
      currentPage={currentPage}
      onNavigate={onNavigate}
      isModalOpen={isModalOpen}
    >
      {children}
    </DefaultPageLayout>
  );
};
